import React, { useState, useEffect } from 'react';
import { setTitle } from "../helpers/MetaTag";
import Input from "../components/form/Input";
import Button from "../components/form/Button";
import toastr from "toastr";
import { useNavigate } from "react-router";
import Searching from '../components/Searching';
import NoDataFound from '../components/NoDataFound';
import { useDispatch } from "react-redux";
import { authLogin } from "../store/authSlice";

import { postData } from "../services/api";
import { useTranslation } from "react-i18next";
import Image from '../components/elements/Image';
import { MAIN_LOGO } from '../constant/Constant';
import { Link } from 'react-router-dom';

const CommissionPay = () => {
  setTitle("Succession Now | Pay Commission");
  const { i18n,t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [isCheck,setIsCheck] = useState(1);
  const [message,setMessage] = useState('');
  const company = new URLSearchParams(window.location.search).get("company");
  const staffCode = new URLSearchParams(window.location.search).get("staff-type");
  const staffId = new URLSearchParams(window.location.search).get("staff");

  useEffect(() => {
    const verifyFn = async () => {
        setLoading(true);
        try {
        const userData = await postData("commission/pay-via-mail", {
          company_id : company,
          staff_id : staffId,
          staff_code : staffCode
        });
        if (userData.status && userData.status === 200) {
            setLoading(false);
            setIsCheck(2);
            setMessage(userData?.message);
        } else {
            setLoading(false);
            setMessage(userData.message)
        }
        } catch (error) {
            setLoading(false);
            toastr.success(error.message);
        }
    };
    verifyFn();
}, []);


  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-slate-100 py-10">
      <div className="w-full max-w-sm">
      <Link to={"/"}>
              <div className="h-14 w-full flex justify-center object-contain mb-5">
                <Image
                  src={MAIN_LOGO}
                  alt={""}
                  width={"100%"}
                  height={"100%"}
                  classes={"object-contain object-center"}
                />
              </div>
            </Link>
        <div className="w-full bg-white rounded shadow-md py-8 px-6">
          {
            (isCheck && isCheck === 1)?
            <div className="divide-y divide-slate-200 space-y-4">
              <Searching label={t('loading')}/>
              {/* {
                  loading?<Searching label={'Loading...'}/>:<NoDataFound label={'No Data found!'}/>
              }   */}
            </div>:
            <div className="bg-gray-100 ">
              <div className="bg-white p-6 mx-auto md:mx-auto">
                <div className="text-green-600 w-16 h-16 mx-auto my-6 text-6xl flex items-center justify-center">
                  <i className="fa-solid fa-circle-check"></i>
                </div>
                <div className="text-center">       
                    <p className="text-gray-600 my-2">{message}</p>             
                    <div className="py-10 text-center">
                      <Button
                        buttonClasses="mx-auto"
                        buttonLabelClasses=""
                        buttonType={"button"}
                        buttonIcon={"fa-light fa-arrow-right-to-arc"}
                        buttonIconPosition={"left"}
                        buttonLabel={t('home')}
                        buttonLink={'/'}
                        buttonHasLink={true}
                      />
                    </div>
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default CommissionPay;